import { QuestionIds } from '../constants/QuestionIds';
import { Steps } from '../constants/StepsLabels';
import { PersonalizationSectionQuestionIds } from '../PersonalizationQuestionIds';

export const InsomniaQuizV2Steps: Map<Steps, QuestionIds[]> = new Map([
  [
    Steps.Quiz,
    [
      QuestionIds.IsiQ1,
      QuestionIds.IsiQ2,
      QuestionIds.IsiQ3,
      QuestionIds.IsiQ4,
      QuestionIds.IsiQ5,
      QuestionIds.AboutYouProof1,
    ],
  ],
  [
    Steps.Sleep,
    [
      QuestionIds.RMeqQ1,
      QuestionIds.RMeqQ2,
      QuestionIds.RMeqQ3,
      QuestionIds.RMeqQ4,
      QuestionIds.RMeqQ5,
      QuestionIds.AboutYouProof1,
    ],
  ],
  [
    Steps.AboutYou,
    [
      QuestionIds.AboutYouGender,
      QuestionIds.AboutYouAge,
      QuestionIds.AboutYouRoutine,
      QuestionIds.AboutYouKids,
      QuestionIds.AboutYouActivity,
      QuestionIds.SleepAndActivityProof2,
      QuestionIds.SleepAndActivityCoffee,
      QuestionIds.SleepAndActivityDinner,
      QuestionIds.SleepAndActivityAfterMidnight,
      QuestionIds.SleepAndActivityLessThanEightHours,
      QuestionIds.SleepAndActivityExtraMotivation,
    ],
  ],
  [Steps.Personalization, PersonalizationSectionQuestionIds],
]);
